<template>
    <div
        class="month-budget-form-single"
        :class="{
            'month-budget-form-single_mobile': isMobile
        }"
    >
        <v-card
            class="pa-4"
        >
            <card-form
                :validator="$validator"
                :form-errors.sync="errors"
                :model.sync="model"
                :id.sync="id"
                route-edit="edit_month_budget"
                action-load="loadMonthBudget"
                action-create="createMonthBudget"
                action-edit="editMonthBudget"
                :is-new.sync="isNew"
                dont-show-btns
                :show-header="false"
                ref="cardForm"
                @submitted="submitted"
            >
                <v-select
                    v-model="model.type"
                    :label="$t('msg.type')"
                    data-vv-name="type"
                    :error-messages="errors.collect('type')"
                    outlined
                    hide-details="auto"
                    :dense="!isMobile"
                    :items="types"
                    @change="changeType"
                    ref="type"
                ></v-select>
                <div v-show="model.type === 'group'">
                    <v-autocomplete
                        v-model="model.group_id"
                        :label="$t('msg.group')"
                        data-vv-name="group_id"
                        :error-messages="errors.collect('group_id')"
                        v-validate="'required_if:type,group'"
                        :items="getGroups"
                        outlined
                        :dense="!isMobile"
                        class="mt-4"
                        hide-details="auto"
                    >
                        <template v-slot:selection="{item}">
                            {{ item.text }}
                            <v-chip
                                small
                                :class="{
                            'bg-green-light': item.type === 'income',
                            'bg-red-light': item.type === 'expenses'
                        }"
                                style="margin-left: 8px !important;"
                            >{{ $t('typeTransaction.'+item.type) }}</v-chip>
                        </template>
                        <template v-slot:item="{item}">
                            {{ item.text }}
                            <v-chip
                                small
                                :class="{
                            'bg-green-light': item.type === 'income',
                            'bg-red-light': item.type === 'expenses'
                        }"
                                class="ml-2"
                            >{{ $t('typeTransaction.'+item.type) }}</v-chip>
                        </template>
                    </v-autocomplete>
                    <div>
                        <div
                            v-for="(plan, key) in model.plans"
                            :key="key"
                            class="mt-4 d-flex align-start"
                        >
                            <v-text-field
                                v-model.number="plan.amount"
                                :label="$t('msg.amount')"
                                :data-vv-name="'plans['+key+']amount'"
                                :error-messages="errors.collect('plans['+key+']amount')"
                                v-validate="'required_if:type,group|min_value:1'"
                                outlined
                                :dense="!isMobile"
                                hide-details="auto"
                                style="flex: 1;"
                                type="number"
                                min="1"
                            ></v-text-field>
                            <v-select
                                :label="$t('msg.currency')"
                                v-model="plan.currency_id"
                                :error-messages="errors.collect('plans['+key+']currency_id')"
                                :data-vv-name="'plans['+key+']currency_id'"
                                v-validate="'required_if:type,group|uniq_currency_id:plans'"
                                :items="currencies"
                                item-value="id"
                                outlined
                                :dense="!isMobile"
                                hide-details="auto"
                                class="ml-4"
                                style="flex: 1;"
                            >
                                <template v-slot:selection="{item}">
                                    {{ item.symbol }} - {{ item.name }}
                                </template>
                                <template v-slot:item="{item}">
                                    {{ item.symbol }} - {{ item.name }}
                                </template>
                            </v-select>
                            <!--<input :value="JSON.stringify(model.plans)" hidden ref="plans">-->
                            <input :value="JSON.stringify(model.plans)" hidden ref="plans">
                            <v-btn
                                fab
                                small
                                color="primary"
                                class="ml-4 month-budget-form-single__btn-delete"
                                :disabled="model.plans.length === 1"
                                @click="deleteCurrency(key)"
                                elevation="0"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                        <div class="d-flex justify-center mt-4">
                            <c-btn
                                @click="addCurrency"
                                color="primary"
                            >{{ $t('msg.addAnotherCurrency') }}</c-btn>
                        </div>
                    </div>
                </div>
                <div v-show="model.type === 'transfer'">
                    <v-autocomplete
                        v-model="model.account_id"
                        :label="$t('msg.account')"
                        :error-messages="errors.collect('account_id')"
                        data-vv-name="account_id"
                        v-validate="'required_if:type,transfer'"
                        :items="getAccounts"
                        item-value="id"
                        item-text="name"
                        :loading="accountsLoading"
                        outlined
                        :dense="!isMobile"
                        hide-details="auto"
                        class="mt-4"
                        @change="changeAccount($event)"
                    ></v-autocomplete>
                    <v-text-field
                        v-model.number="model.plans[0].amount"
                        :label="$t('msg.amount')"
                        :data-vv-name="'plans['+0+']amount'"
                        :error-messages="errors.collect('plans['+0+']amount')"
                        v-validate="'required_if:type,transfer'"
                        outlined
                        :dense="!isMobile"
                        hide-details="auto"
                        type="number"
                        min="1"
                        class="mt-4 month-budget-form-single__account"
                    >
                        <template v-slot:append>
                            {{ getCurrencySymbol(model.plans[0].currency_id) }}
                        </template>
                    </v-text-field>
                </div>
                <v-textarea
                    v-model="model.desc"
                    :label="$t('msg.description')"
                    data-vv-name="desc"
                    :error-messages="errors.collect('desc')"
                    outlined
                    :dense="!isMobile"
                    hide-details="auto"
                    class="mt-4"
                ></v-textarea>
            </card-form>
        </v-card>
        <btns-wrap class="mt-3">
            <c-btn
                v-if="!isNew"
                color="error"
                :loading="deleteLoading"
                @click="deleteItem"
            >{{ $t('msg.delete') }}</c-btn>
            <c-btn
                color="primary"
                @click="$refs.cardForm.submit(true)"
            >{{ isNew ? $t('msg.toCreate') : $t('msg.save') }}</c-btn>
        </btns-wrap>
    </div>
</template>

<script>
export default {
    props: {
        month: {type: String, required: true}
    },
    data() {
        return {
            isNew: undefined,
            id: undefined,
            model: {
                id: null,
                month: this.month,
                type: 'group',
                group_id: null,
                account_id: null,
                desc: null,
                plans: [
                    {amount: null, currency_id: null}
                ]
            },
            types: [
                {value: 'group', text: this.$t('msg.group')},
                {value: 'transfer', text: this.$t('msg.transfer')},
            ],
            groups: [],
            accounts: [],
            currencies: [],
            groupsLoading: false,
            accountsLoading: false,
            addedPlans: [],
            deleteLoading: false
        };
    },
    computed: {
        getGroups() {
            let ret = []

            this.groups.forEach(item => {

                let addedPlan = this.addedPlans.find(v => v.type === 'group' && v.group_id === item.id);

                if (item.is_archive === false && (addedPlan === undefined || !this.isNew)) {
                    ret.push({
                        value: item.id,
                        text: item.name,
                        type: item.type,
                    });
                }
            })

            return ret;
        },
        getAccounts() {
            let items = [];

            this.accounts.forEach(item => {

                let currency = '';

                const cur = this.currencies.find(v => v.id === item.currency_id);
                if (cur !== undefined) currency = cur.symbol;

                let addedPlan = this.addedPlans.find(v => v.type === 'transfer' && v.account_id === item.id);

                if (addedPlan === undefined) {
                    items.push({
                        id: item.id,
                        name: item.name + ' (' + this.$options.filters.numFormat(item.balance, '0,0.00') + ' ' + currency + ')'
                    });
                }
            });

            return items;
        },
    },
    methods: {
        addCurrency() {
            this.model.plans.push({amount: null, currency_id: null});
        },
        deleteCurrency(i) {
            this.model.plans.splice(i, 1);
        },
        loadAccounts() {
            this.accountsLoading = true;
            this.$store.dispatch('loadAccounts')
                .then(res => this.accounts = res)
                .finally(() => this.accountsLoading = false);
        },
        loadGroups() {
            this.groupsLoading = true;
            this.$store.dispatch('loadGroups', {params: {}})
                .then(res => this.groups = res)
                .finally(() => this.groupsLoading = false);
        },
        loadCurrencies() {
            this.$store.dispatch('loadCurrencies')
                .then(res => this.currencies = res);
        },
        changeType() {
            this.model.plans = [{amount: null, currency_id: null}];
            this.model.group_id = null;
            this.model.account_id = null;
        },
        changeAccount(v) {

            let account = this.accounts.find(_v => _v.id === v);

            if (account !== undefined) {
                this.model.plans[0].currency_id = account.currency_id;
            }
        },
        getCurrencySymbol(id) {

            if (!id) {
                return null;
            }

            const cur = this.currencies.find(v => v.id === id);
            if (cur !== undefined) {
                return cur.symbol;
            }

            return null;
        },
        loadMonthBudgets() {
            this.$store.dispatch('loadMonthBudgets', {
                params: {
                    month: this.month,
                }
            })
                .then(res => this.addedPlans = res.accounted);
        },
        submitted() {
            this.$router.push({name: 'month_budget', query: {month: this.month}});
        },
        deleteItem() {
            if (confirm(this.$t('msg.delete')+'?')) {
                this.deleteLoading = true;
                this.$store.dispatch('deleteMonthBudget', {id: this.id})
                    .then(() => {
                        this.$router.push({name: 'month_budget', query: {month: this.month}});
                    })
                    .finally(() => this.deleteLoading = false);
            }
        },
    },
    created() {
        this.loadAccounts();
        this.loadGroups();
        this.loadCurrencies();
        this.loadMonthBudgets();
    }
}
</script>

<style lang="scss">
.month-budget-form-single {
    &.month-budget-form-single_mobile {
        .month-budget-form-single__btn-delete {
            margin-top: 13px;
        }
        .month-budget-form-single__account {
            .v-input__append-inner {
                margin-top: 20px !important;
            }
        }
    }
    .month-budget-form-single__btn-delete {
        margin-top: 5px;
    }
    .month-budget-form-single__account {
        .v-input__append-inner {
            margin-top: 12px !important;
        }
    }
}
</style>